import { MsalService } from '@azure/msal-angular';
import { UserRoleChangeService } from './user-role-change.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-role-change',
  templateUrl: './user-role-change.component.html',
  styleUrls: ['./user-role-change.component.scss']
})
export class UserRoleChangeComponent implements OnInit {

  showPop = false;
  constructor(private userRoleChangeService: UserRoleChangeService, private authService: MsalService) { }

  ngOnInit(): void {
    this.userRoleChangeService.showPop.subscribe(() => {
      this.showPop = true;
    });
  }

  logout(): void {
    this.authService.logout();
  }

}
